
export default {
  namespaced: true,
  state: { /* = data */
    provisionPayload: {
      hole_id: null,
      zone_id: null,
      tee_marker_id: null,
      location_id: null,
      quadrant_id: null,
      sensor_depth: null,
      prongs_depth: null,
      location_code: null,
      location_desc: null,
      location_note: null,
      grass_type_id:null
    },
    hole: {},
    step: 0,
    loading: {
      btnContinue: false,
    },
    canBack: async () => true,
    canContinue: async () => true,
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */
  },


  mutations: { /* Mutations are responsible to change the state */
    setProvisionPayload(state, provisionPayload) {
      state.provisionPayload = { ...state.provisionPayload, ...provisionPayload };
    },

    setHole(state, hole) {
      state.hole = hole;
    },

    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },
  },

};
